
/**
 * Define namespace
 *
 */
var Intesa = Intesa || {};


/**
 * Intesa loan calculator BIB
 *
 */
Intesa.LoanCalculatorVUB = function() {
    
	/**
	 * Local variables
	 *
	 */
	var loan = this;
	var development = false;
	var invalidJsonFiles = false;
	var genericSettings = {};
	var calculatorLabels = {};

	/**
	 * Global variables
	 *
	 */
	this.MAX_ITERATIONS = 50;
	this.activeCalculator = null;
	this.activeVariant = {};
	this.activeMortgage = {};
	this.activeCurrency = {};
	this.activeInterestType = {};
	this.activeInterestPeriod = {};
	this.errorState = false;
	this.defaultEducation = null;
	this.navigator = null;

	// values
	this.tenorUnit = null;
	this.loanNumberOfInstallments = null;
	this.monthlyInstallment = 0;
	this.currentMonthlyInstallment = 0;
	this.mortgageAmount = 0;
	this.interestRate = 0;
	this.currency = null;
	this.fee = 0;
	this.feeForDepositLien = 0;
	this.urlParams = {};
	this.interestType = 'FIXED';
	this.loanInterestRatePeriods = null;
	this.feeAccountRange = {};
	
	this.monthlyInterestPayment = 0;
	this.amountToBeRepayed = 0;

    /**
     * Init component
     *
     */
    this.init = function() {
        // check if calculator exists
        var isVUB = $('html').attr('data-bank') == 'VUB';
		var isLoanCalculator = $('.loan-calculator').length > 0;
        if (!$("section.com16-14").length || !isVUB || !isLoanCalculator) return;

		// get settings and labels
		loan.getSettingsAndLabelsJsonData();
        loan.setVisibleCalculatorAsActive();
		loan.initNavigator(loan.activeCalculator);
        loan.setActiveVariant();
        loan.setActiveMortgage( loan.getDefaultMortgage() );
		loan.setActiveCurrency( loan.getDefaultCurrency() );
		loan.setActiveInterestType( loan.getDefaultInterestType() );

		loan.mapSliders();


        loan.updateCalculatorInputs();
		loan.updateCalculatorOutputs();

        loan.attachChangeEvents();
		loan.attachDataLayerClickEvent();

		loan.formatInputDecimal();
		
		var productCategory = loan.activeVariant.productCategory;
		if( productCategory === "OVERDRAFT"){
			loan.substituteDisclaimerOverdraft();
		}
		
		if( productCategory === "LOAN_FOR_EVERYTHING"){
			if($('[name="borrowAmount"]').length){
				$( '[name="borrowAmount"]' ).focusout(function() {
					var newValue = parseInt($(this).val());
					var roundedValue = Math.ceil(newValue / 10) * 10;
					$( '[name="borrowAmount"]' ).val(roundedValue);
			    })
			}
		}

    };

	/**
	 * @param calculator The active calculator
	 */
	this.initNavigator = function(calculator) {
        loan.navigator = Intesa.CalculatorNavigation.getInstance(calculator);
        loan.navigator.init();
	}


	/**
	 * Get Calculator Inputs
	 *
	 */
	this.getCalculatorInputs = function() {

		var inputs = $( '[data-algorithm-input]', loan.activeCalculator );
		var numberOfInputs = inputs.length;

		for( var i = 0; i < numberOfInputs; i++ ) {

			// get name
			var inputLabel = inputs[i].getAttribute( 'data-algorithm-input' );

			// get value
			var inputValue = inputs[i].value;

			//replace comma with dot
            inputValue = inputValue.replace(',', '.').replaceAll(genericSettings.separator, '');

			// parse numbers
			if( inputLabel !== 'currency' )	inputValue = parseFloat( inputValue );

			// set global property
			loan[inputLabel] = inputValue;
			
			if(inputLabel == "tenorInYears"){
				if(loan.tenorUnit === 'YEARS'){
					loan.loanNumberOfInstallments = inputValue * 12;
				} else {
					loan.loanNumberOfInstallments = inputValue;
				}
			}
			if($( '.js-interest-period', loan.activeCalculator ).length !== 0 && inputLabel == "interestRate"){
				loan.loanInterestRatePeriods = loan.activeInterestPeriod.monthDuration / 12;

				var periods = loan.activeInterestType.periods;
				var selectVal = $( '.js-interest-period', loan.activeCalculator ).val();
				var indexSelectYear=$( '.js-interest-period', loan.activeCalculator).prop("selectedIndex");
				periods.forEach( function( period,index ) {
					if(period.interestRate != undefined && period.interestRate.toString() == selectVal && indexSelectYear==index){
						loan.loanInterestRatePeriods = period.monthDuration / 12;
						loan.activeInterestPeriod = period;
					}
				} );
			}

		}

	};


    /**
     * Append Calculator Outputs
     *
     */
    this.appendCalculatorOutputs = function() {
		const currencyDataLabels = [
			'monthlyInstallment', 
			'borrowAmount', 
			'monthlySavings', 
			'totalSavings', 
			'savings',
			'interestRate',
			'apr',
			'costs',
			'monthlyInterestPayment',
			'aprc',
			'interestRateNoBenefit',
			'costsNoBenefit',
			'monthlyInstallmentNoBenefit',
			'aprcNoBenefit',
			'fee',
			'monthlyInsuranceLoan',
			'amountToBeRepayed',
			'flexidebetOverdraft',
			'monthlyAccountFeeOverdraft',
		];

        var outputs = $('[data-algorithm-output]', loan.activeCalculator);
		var outputValue = "";

        outputs.each(function() {
            var inputLabel = $(this).attr('data-algorithm-output');
            if ( currencyDataLabels.includes(inputLabel) ) {
                outputValue = number_format(loan[inputLabel], 2, genericSettings.decimal, genericSettings.separator);
			}
			else if(inputLabel === 'mortgageAmount'){
                outputValue = number_format(loan[inputLabel], 0, genericSettings.decimal, genericSettings.separator);
			}
			else if(inputLabel === "fixedInterestPeriod"){
				outputValue = loan.getInterestPeriodLabel(loan.activeInterestPeriod.monthDuration);
			}
			else if(inputLabel === "feeInput"){
				outputValue = loan.activeCurrency.glGenericCalculationList[0].fee * 100;
			}
			else{
              	outputValue = loan[inputLabel];
            }
            $(this).text(outputValue);
        });

    };


	 /**
     * Set Active Calculator
     *
     */
    this.setActiveCalculator = function(calculator) {

        loan.activeCalculator = calculator;

    };

    /**
     * Set Visible Calculator As Active
     *
     */
    this.setVisibleCalculatorAsActive = function(calculators) {

		var width = $(window).width();
		var calculatorResolution = "desktop";
		if(width < 768){
			var calculatorResolution = "mobile" ;
		}
		if(!calculators) {
			var calculators = $( '[data-calculator='+calculatorResolution+']' );
		}
        var calculatorFound = false;

        calculators.each(function() {

            // set visible calculator as active
            if ($(this).is(":visible")) {

                loan.activeCalculator = $(this);
                calculatorFound = true;

            }

        });

        // handle no calculator active by default
        if (!calculatorFound) loan.activeCalculator = $('[data-calculator='+calculatorResolution+']').first();
    };


    /**
     * Set Active Variant
     *
     */
    this.setActiveVariant = function() {

        if (loan.activeCalculator) {

            var calculatorData = loan.activeCalculator.siblings('.calculatorData').val();

            try {

                // get calculator data
                var variantData = JSON.parse(calculatorData);
                loan.activeVariant = variantData.glGenericSimulatorParams;

            } catch (e) {

                console.error('Calculator JSON file invalid');

            }

        }

    };


	/**
	 * Set Active Mortgage
	 *
	 */
	this.setActiveMortgage = function( value ) {

		var mortgageOptions = loan.activeVariant.glProductVariantList;
		var numberOfMortgage = mortgageOptions.length;

		// cicle all the martgage options
		for( var i = 0; i < numberOfMortgage ; i++ ) {

			if( mortgageOptions[i].variantType === value ) {

				loan.activeMortgage = mortgageOptions[i];
				break;

			}

		}

		loan['mortgage'] = value;

	};


	/**
	 * Get Default Mortgage
	 *
	 */
	this.getDefaultMortgage = function() {

		if( loan.activeVariant ) {

			var mortgageOptions = loan.activeVariant.glProductVariantList;
			var numberOfMortgage = mortgageOptions.length;
			var label = '';
			var mortgageFound = false;

			// cicle all the martgage options
			for( var i = 0; i < numberOfMortgage ; i++ ) {

				if( mortgageOptions[i].default === true ) {

					label = mortgageOptions[i].variantType;
					loan['mortgage'] = label;
					mortgageFound = true;
					break;

				}

			}

			if( !mortgageFound ) label = mortgageOptions[0].variantType;

			loan['mortgage'] = label;

			return label;

		}

	};


	/**
	 * Set Active Currency
	 *
	 */
	this.setActiveCurrency = function( value ) {

		var currencyOptions = loan.activeMortgage.glConfigurationList;
		var numberOfCurrency = currencyOptions.length;

		// cicle all the currencies
		for( var i = 0; i < numberOfCurrency ; i++ ) {

			if( currencyOptions[i].currency === value ) {

				loan.activeCurrency = currencyOptions[i];
				break;

			}

		}

	};


	/**
	 * Get Default Currency
	 *
	 */
	this.getDefaultCurrency = function() {

		var currencyOptions = loan.activeMortgage.glConfigurationList;
		var numberOfCurrency = currencyOptions.length;
		var label = '';

		// cicle all the currencies
		for( var i = 0; i < numberOfCurrency ; i++ ) {

			if( currencyOptions[i].default === true ) {

				label = currencyOptions[i].currency;
				break;

			}

		}

		return label;

	};


	/**
	 * Get Settings And Labels Json Data
	 */
	this.getSettingsAndLabelsJsonData = function() {

		var settings = $( "#genericSettings" );
		var labels = $( "#calculatorLabels" );

		try {

			// get generic settings
			if( settings.length ) {
				genericSettings = JSON.parse( settings.val() );
			}

			// get calculator labels
			if( labels.length ) {
				calculatorLabels =  JSON.parse( labels.val() );
			}

		} catch(e) {

			console.error( 'Settings or Labels JSON file invalid' );
			invalidJsonFiles = true;

		}

	};

	/**
	 * Update Calculator Inputs
	 *
	 */
	this.updateCalculatorInputs = function() {
		loan.initAccountFeeAccountRange();
		loan.updateAccountFeeInput();
		loan.initFlexidebetInputs();
		loan.updateBorrowAmountInput();
		loan.updateCurrentMonthlyInstallment();
        loan.updateCurrencySelect();
		loan.initInterestPeriodSelect();
		loan.updateTenorUnit();
        loan.updateTenorSlider();
		loan.initInterestRateInput();
		loan.initRemainingRepaymentsInput();
		loan.initDeferredRepayments();
	};


	/**
	 * Update Calculator Outputs
	 */
	this.updateCalculatorOutputs = function() {
        loan.getCalculatorInputs();
		loan.initFee();
		loan.checkErrors();
		loan.calculateResults();
        loan.appendCalculatorOutputs();

		loan.updateDataLayer();
    };


	/**
	 * Update Amount Input
	 *
	 */
	this.updateBorrowAmountInput = function() {
		var input = $( '[data-algorithm-input="borrowAmount"]', loan.activeCalculator );

		if( input.length ) {

			var minimumAmount = loan.activeCurrency.glGenericCalculationList[0].minimumAmount;
			var maximumAmount = loan.activeCurrency.glGenericCalculationList[0].maxAmountForOnline;
			var defaultAmount = loan.activeCurrency.glGenericCalculationList[0].defaultAmount;

			// update minimum
			input.attr( 'data-parsley-min', minimumAmount );
			var min = number_format( minimumAmount, 2, genericSettings.decimal, genericSettings.separator );
			$( '[data-loan-min]', loan.activeCalculator ).text( min );

			// update maximum
			input.attr( 'data-parsley-max', maximumAmount );
			var max = number_format( maximumAmount, 2, genericSettings.decimal, genericSettings.separator );
			$( '[data-loan-max]', loan.activeCalculator ).text( max );

			// insert default value if the value is 0
			if ((	input.val() == "0" || parseInt(input.val() ) < defaultAmount)){
				var formattedAmount = number_format( defaultAmount, 2, genericSettings.decimal, genericSettings.separator );
			
				input.val( formattedAmount );

			}

			// validate
			input.parsley(loan.formatParsleyDecimalValue()).validate();
		}

	};


	/**
	 * Update Account Fee Input
	 *
	 */

	this.updateAccountFeeInput = function() {

		var input = $( '[data-algorithm-input="monthlyAccountFee"]', loan.activeCalculator );

		if( input.length ) {

			var minimumAmount = loan.activeCurrency.glGenericCalculationList[0].minimumAccountFee;
			var maximumAmount = loan.activeCurrency.glGenericCalculationList[0].maximumAccountFee;
			var defaultAmount = loan.activeCurrency.glGenericCalculationList[0].defaultAccountFee;

			// update minimum
			input.attr( 'data-parsley-min', minimumAmount );
			var min = number_format( minimumAmount, 2, genericSettings.decimal, genericSettings.separator );
			$( '[data-accountFee-min]', loan.activeCalculator ).text( min );

			// update maximum
			input.attr( 'data-parsley-max', maximumAmount );
			var max = number_format( maximumAmount, 2, genericSettings.decimal, genericSettings.separator );
			$( '[data-accountFee-max]', loan.activeCalculator ).text( max );

			// insert default value if the value is 0
			if ((	input.val() == "0" || parseInt(input.val() ) < defaultAmount)){
				var formattedAmount = number_format( defaultAmount, 2, genericSettings.decimal, genericSettings.separator );
			
				input.val( formattedAmount );

			}

			// validate
			input.parsley(loan.formatParsleyDecimalValue()).validate();
		}

	};
	
	
	/**
	 * Initialize Disclaimer Overdraft
	 *
	 */
	
	
   this.substituteDisclaimerOverdraft = function() {

		 var stringhtml = $("#disclaimer-d-306").get(0).outerHTML.replace("{flexidebet}", "<span id='disclaimer__flexidebet__desktop'>" +  loan.flexidebet != undefined ? number_format(loan.flexidebet, 2, genericSettings.decimal, genericSettings.separator) : '' + "</span>").replace("{monthlyAccountFee}", "<span id='disclaimer__monthlyAccountFee__desktop'>" + loan.monthlyAccountFee != undefined ? number_format(loan.monthlyAccountFee, 2, genericSettings.decimal, genericSettings.separator) : '' + "</span>").replace("{aprc}", "<span id='disclaimer__aprc__desktop'>" + loan.aprc != undefined ? number_format(loan.aprc, 2, genericSettings.decimal, genericSettings.separator) : '' + "</span>").replace("{amountToBeRepayed}", "<span id='disclaimer__amountToBeRepayed__desktop'>" + loan.amountToBeRepayed != undefined ? number_format(loan.amountToBeRepayed, 2, genericSettings.decimal, genericSettings.separator) : '' + "</span>");
		
		 $("#disclaimer-d-306").replaceWith(stringhtml);
		 
		 var stringhtml = $("#disclaimer-m-306").get(0).outerHTML.replace("{flexidebet}", "<span id='disclaimer__flexidebet__mobile'>" + loan.flexidebet != undefined ? number_format(loan.flexidebet, 2, genericSettings.decimal, genericSettings.separator) : '' + "</span>").replace("{monthlyAccountFee}", "<span id='disclaimer__monthlyAccountFee__mobile'>" + loan.monthlyAccountFee != undefined ? number_format(loan.monthlyAccountFee, 2, genericSettings.decimal, genericSettings.separator) : '' + "</span>").replace("{aprc}", "<span id='disclaimer__aprc__mobile'>" + loan.aprc != undefined ? number_format(loan.aprc, 2, genericSettings.decimal, genericSettings.separator) : '' + "</span>").replace("{amountToBeRepayed}", "<span id='disclaimer__amountToBeRepayed__mobile'>" + loan.amountToBeRepayed != undefined ? number_format(loan.amountToBeRepayed, 2, genericSettings.decimal, genericSettings.separator) : '' + "</span>");
			
		 $("#disclaimer-m-306").replaceWith(stringhtml);
		 
    };
   
    
    /**
	 * Update Disclaimer Overdraft
	 *
	 */
   
    this.updateDisclaimerOverdraft = function() {
    	
    	$("#disclaimer__aprc__desktop").text(loan.aprc.toString());
		$("#disclaimer__flexidebet__desktop").text(loan.flexidebet.toString());
		$("#disclaimer__monthlyAccountFee__desktop").text(loan.monthlyAccountFee.toString());
		$("#disclaimer__amountToBeRepayed__desktop").text(loan.amountToBeRepayed.toString());
	
		$("#disclaimer__aprc__mobile").text(loan.aprc.toString());
		$("#disclaimer__flexidebet__mobile").text(loan.flexidebet.toString());
		$("#disclaimer__monthlyAccountFee__mobile").text(loan.monthlyAccountFee.toString());
		$("#disclaimer__amountToBeRepayed__mobile").text(loan.amountToBeRepayed.toString());
			 
    };


	
	/**
	 * Update Flexidebet Inputs -- input + slider ---
	 *
	 */

	this.initFlexidebetInputs = function () {

		var input = $( '[data-algorithm-input="flexidebet"]', loan.activeCalculator );

		var inputSliderValue = $( '[data-algorithm-input="flexidebet-slider"]', loan.activeCalculator );

		var inputSlider = $("[name='flexidebet-slider']", loan.activeCalculator);

		if( input.length && inputSlider.length) {

			var minimumAmount = loan.activeCurrency.glGenericCalculationList[0].minimumAmount;
			var maximumAmount = loan.activeCurrency.glGenericCalculationList[0].maxAmountForOnline;
			var defaultAmount = loan.activeCurrency.glGenericCalculationList[0].defaultAmount;

			// update minimum
			input.attr( 'data-parsley-min', minimumAmount );
			var min = number_format( minimumAmount, 2, genericSettings.decimal, genericSettings.separator );
			$( '[data-flexidebet-min]', loan.activeCalculator ).text( min );

			// update maximum
			input.attr( 'data-parsley-max', maximumAmount );
			var max = number_format( maximumAmount, 2, genericSettings.decimal, genericSettings.separator );

			loan.borrowAmount = defaultAmount;

			// insert default value if the value is 0
			if ((	input.val() == "0" || parseInt(input.val() ) < defaultAmount)){
				var formattedAmount = number_format( defaultAmount, 2, genericSettings.decimal, genericSettings.separator );
			
				input.val( formattedAmount );

			}

			// validate Input 
			input.parsley(loan.formatParsleyDecimalValue()).validate();


			//initiliate slider flexidebet input
			$( '[data-flexidebet-max]', loan.activeCalculator ).text( max );
			$("[data-min-flexidebet-unit]", loan.activeCalculator).text(min);
			$("[data-max-flexidebet-unit]", loan.activeCalculator).text(max);
			inputSlider.attr("data-value", defaultAmount);
			inputSlider.attr("value",defaultAmount);
			inputSlider.attr("data-slider-max",maximumAmount);
			inputSlider.attr("data-slider-min",minimumAmount);
			inputSliderValue.attr("value", defaultAmount);
			var index = parseInt( inputSlider.attr( 'data-slider-index' ) );
			var slider = window.sliderbootstrap[index];
			slider.slider('destroy');
			slider.slider({ tooltip: 'show' });
			slider.slider('setValue', defaultAmount);
			inputSlider.siblings( '.qty' ).trigger('change');

			slider.on( 'slide', function() {
				var value = slider.slider('getValue');
				inputSliderValue.find('.qty').val(value);
				inputSlider.siblings( '.qty' ).trigger('change');
			} );
		}



	};



	this.initAccountFeeAccountRange = function (){

		loan.activeCurrency.glGenericCalculationList[0].feeRange ? loan.feeAccountRange = loan.activeCurrency.glGenericCalculationList[0].feeRange : null;


	}

	/**
	 * Update Current Monthly Installment Input
	 *
	 */
	this.updateCurrentMonthlyInstallment = function() {
		var input = $( '[data-algorithm-input="currentMonthlyInstallment"]', loan.activeCalculator );

		if( input.length ) {

			/*
			var minimumAmount = loan.activeCurrency.glGenericCalculationList[0].minimumAmount;
			var maximumAmount = loan.activeCurrency.glGenericCalculationList[0].maxAmountForOnline;

			// update minimum
			input.attr( 'data-parsley-min', minimumAmount );
			var min = number_format( minimumAmount, 2, genericSettings.decimal, genericSettings.separator );
			$( '[data-loan-min]' ).text( min );

			// update maximum
			input.attr( 'data-parsley-max', maximumAmount );
			var max = number_format( maximumAmount, 2, genericSettings.decimal, genericSettings.separator );
			$( '[data-loan-max]' ).text( max );
			*/

			var defaultAmount = loan.activeCurrency.glGenericCalculationList[0].defaultCurrentMonthlyInstallment;
			// insert default value if the value is 0
			if ((	input.val() == "0" || parseInt(input.val() ) < defaultAmount)){
			
				input.val( defaultAmount );

			}

			// validate
			input.parsley(loan.formatParsleyDecimalValue()).validate();

		}

	};
	
	/**
	 * Update Currency Select
	 *
	 */
	this.updateCurrencySelect = function() {

		var currencyOptions = loan.activeMortgage.glConfigurationList;
		var select = $( '[data-algorithm-input="currency"]', loan.activeCalculator );
		var html = '';

		if( select.length ) {

			// clear select
			select.html('');

			// generate select html
			currencyOptions.forEach( function( currency ) {

				currency = currency.currency;

				if( currency === loan.activeCurrency.currency ) {
					html += '<option value="' + currency + '" selected>' + currency + '</option>';
				} else {
					html += '<option value="' + currency + '">' + currency + '</option>';
				}

			} );

			if(currencyOptions.length <= 1)
			{
				select.attr('disabled', 'disabled')
			}

			// append options
			select.append( html );

		}

	};



	/**
	 * Get Tenor In Months
	 *
	 */
	this.getTenorInMonths = function() {
		if(loan.tenorUnit === 'YEARS') 
			return (loan.tenorInYears * 12)
		else
			return loan.tenorInYears;
	};



	/**
	 * Update Tenor Unit
	 *
	 */
	this.updateTenorUnit = function() {

		// get tenor unit
		loan.tenorUnit = loan.activeCurrency.tenorUnit;

		// get label
		var tenorUnitLabel = calculatorLabels[loan.tenorUnit];

		// insert label
		$( '[data-tenor-unit]', loan.activeCalculator ).text( tenorUnitLabel );

	};


	/**
	 * Update Tenor Slider
	 *
	 */
	this.updateTenorSlider = function() {

		var input = $( '.rangeslider.rangeslider--2', loan.activeCalculator );

		if( input.length ) {

			var index = parseInt( input.attr( 'data-slider-index' ) );
			var slider = window.sliderbootstrap[index];
			var wrapper = input.parents('.sliderRange__wrapper');

			// set step value
			var step = loan.activeCurrency.glGenericCalculationList[0].amountList[0].tenorScalingFactor;
			input.attr( 'data-slider-step', step );

			// set minimum
			var tenorMin = loan.activeCurrency.glGenericCalculationList[0].amountList[0].minimumTenor;
			if( loan.tenorUnit === 'YEARS' ) tenorMin = tenorMin / 12;
			input.attr( 'data-slider-min', tenorMin );
			wrapper.find( '[data-min-tenor]' ).html( tenorMin );

			// set maximum
			var tenorMax = loan.activeCurrency.glGenericCalculationList[0].amountList[0].maximumTenor;
			if( loan.tenorUnit === 'YEARS' ) tenorMax = tenorMax / 12;
			input.attr( 'data-slider-max', tenorMax );
			wrapper.find( '[data-max-tenor]' ).html( tenorMax );

			// rebuild sliderf
			slider.slider('destroy');
			slider.slider({ tooltip: 'show' });


			var tenorDefault = loan.activeCurrency.glGenericCalculationList[0].amountList[0].defaultTenor ?  loan.activeCurrency.glGenericCalculationList[0].amountList[0].defaultTenor : tenorMin;
			if( loan.tenorUnit === 'YEARS' ) tenorDefault = tenorDefault / 12;

            $('input[data-algorithm-input="loanDuration"]', loan.activeCalculator).attr("data-parsley-min", slider.attr("data-slider-min"));
            $('input[data-algorithm-input="loanDuration"]', loan.activeCalculator).attr("data-parsley-max", slider.attr("data-slider-max"));
            $('input[data-algorithm-input="loanDuration"]', loan.activeCalculator).val(tenorDefault);

            var $minValue = $( '[data-min-tenor]', loan.activeCalculator ); $minValue.html( tenorMin );
            var $maxValue = $( '[data-max-tenor]', loan.activeCalculator ); $maxValue.html( tenorMax );


			if(loan.tenorUnit === "YEARS") {
				$minValue.next('[data-tenor-unit]').html( loan.getYearsLabel( tenorMin ) );
				$maxValue.next('[data-tenor-unit]').html( loan.getYearsLabel( tenorMax ) );
			}


			// attach slide event
			slider.slider('setValue', tenorDefault);
			wrapper.find('.qty').val(tenorDefault);
			input.siblings( '.qty' ).trigger('change');

			slider.on( 'slide', function() {
				var value = slider.slider('getValue');
				wrapper.find('.qty').val(value);
				input.siblings( '.qty' ).trigger('change');
			} );

		}

	};


	/**
	 * Attach Change Events
	 *
	 */
	this.attachChangeEvents = function() {
		// on calculator change
        $(document).on('click', '.com15__filterItem', function() {
            var id = $(this).attr('data-filter');
            var calculators = $('.com15__filter[data-filter="' + id + '"]');
			var calculator;
			if($(window).width() < 768) {
				calculator = calculators.find('.calculator-mobile');
			}
			else {
				calculator = calculators.find('.calculator-desktop');
			}

            //	loan['loanpurpose'] = id;
            loan.setActiveCalculator(calculator);
			loan.initNavigator(calculator);
            loan.setActiveVariant();
            loan.setActiveMortgage(loan.getDefaultMortgage());
            loan.setActiveCurrency(loan.getDefaultCurrency());
            loan.setActiveInterestType(loan.getDefaultInterestType());
            loan.updateCalculatorInputs();
            loan.updateCalculatorOutputs();
        });
		

		// enable change slider on click
		$( document ).on( "change", '.rangeslider', function() {
			var value = $( this ).val();
			var wrapper = $( this ).parents( '.sliderRange__wrapper' );
			wrapper.find( '.qty' ).val( value );
			loan.updateCalculatorOutputs();
		} );
		
		$(document).on('keyup', 'input[data-algorithm-input="loanDuration"]', function () {
			var slider = $('.rangeslider.rangeslider--2', loan.activeCalculator);
			var index = parseInt(slider.attr('data-slider-index'));
			slider.slider('setValue', $(this).val(), true);
		});
		
		// on change inputs
		$( document ).on( 'change focusout keyup', '[data-algorithm-input]', function() {
			loan.updateCalculatorOutputs();
		});

		// on click slider buttons
		$( document ).on( "click", '.js-btnMinus, .js-btnAdd', function() {
			$( '[data-algorithm-input="tenorInYears"]' ).trigger( 'change' );
		} );

		$( document ).on( "click", '.js-calc-nav-next', function() {
			if(loan.navigator) {
				loan.navigator.nextPrev(1, this);
			}
		})

		$( document ).on( "click", '.js-calc-nav-prev', function() {
			if(loan.navigator) {
				loan.navigator.nextPrev(-1, this);
			}
		})

		$( document ).on( "click", '.js-btnMinus, .js-btnAdd', function() {
			$(this).parent().find(".rangeslider.flexidebet").trigger( 'change' );
		} );

		$( document ).on( "keyup", '[data-algorithm-input="flexidebet"]', function() {
			var slider = $('.rangeslider.flexidebet', loan.activeCalculator);
			slider.slider('setValue', parseInt($(this).val()), false);
		})

		$( document ).on( "change", '[name="flexidebet-slider"]', function() {
			var input  = $('[data-algorithm-input="flexidebet"]', loan.activeCalculator);
			var sliderValue = parseInt($(this).attr("data-value")).toFixed(2).replaceAll(".", ",");
			input.val(sliderValue);
			loan.updateCalculatorOutputs();
		})

		$( document ).on( "keyup", '[data-algorithm-input="monthlyAccountFee"]', function() {
			loan.updateMinAmountOverdraft();
		})
    };
	

  	/**
	 * Find the new min amount allowed for the new fee
	 *
	 */

	this.updateMinAmountOverdraft = function(){

		var newFee = (loan.monthlyAccountFee).toFixed(2);

		if(this.feeAccountRange.length && newFee){

		newFee = parseFloat(newFee);

			
			this.feeAccountRange.forEach(function(elementInside){


				var minRangeFee = parseFloat(elementInside.minimumRangeFee);

				var maxRangeFee = parseFloat(elementInside.maximumRangeFee);

				var minimumFlexidebetAmount = parseInt(elementInside.minimumFlexidebetAmount);

				if (minRangeFee <= newFee && newFee <= maxRangeFee ){

					var inputSlider = $("[name='flexidebet-slider']", loan.activeCalculator);

					var input = $( '[data-algorithm-input="flexidebet"]', loan.activeCalculator );

					var index = parseInt( inputSlider.attr( 'data-slider-index' ) );

					var slider = window.sliderbootstrap[index];

					var flexidebetAmount = parseFloat($('[data-algorithm-input="flexidebet"]:visible').val());

					var flexidebetElement = $('[data-algorithm-input="flexidebet"]');

					if(flexidebetAmount < minimumFlexidebetAmount){

						flexidebetElement.val(minimumFlexidebetAmount.toFixed(2).replaceAll(".",","));

						slider.slider('setValue', minimumFlexidebetAmount);

					}

					input.attr( 'data-parsley-min', minimumFlexidebetAmount );

					$( '[data-flexidebet-min]', loan.activeCalculator ).text( minimumFlexidebetAmount );
					
					slider.slider('setAttribute', 'min', minimumFlexidebetAmount);

					$("[data-min-flexidebet-unit]", loan.activeCalculator).text(minimumFlexidebetAmount);

					slider.slider("refresh");

					slider.slider('setValue', parseInt(loan.flexidebet));
					
					input.parsley().validate();

				}
					
			});

		}

	}
	  

	
    /**
	 * Set Active Interest Type
	 *
	 */
	this.setActiveInterestType = function( value ) {

		var interestOptions = loan.activeCurrency.glGenericCalculationList[0].interest;
		var numberOfInterests = interestOptions.length;

		// cicle all interest rates
		for( var i = 0; i < numberOfInterests ; i++ ) {

			if( interestOptions[i].interestCode === value ) {

				loan.activeInterestType = interestOptions[i];
				loan['interestRateType'] = value;
				break;

			}

		}

	};


	/**
	 * Get Default Interest Type
	 *
	 */
	this.getDefaultInterestType = function() {

		var interestOptions = loan.activeCurrency.glGenericCalculationList[0].interest;
		var numberOfInterests = interestOptions.length;
		var label = '';

		// cicle all interest rates
		for( var i = 0; i < numberOfInterests ; i++ ) {

			if( interestOptions[i].default === true ) {

				label = interestOptions[i].interestCode;
				break;

			}

		}

		return label;

	};


	/**
	 * Get Tenor In Months
	 *
	 */
	this.getTenorInMonthsTantoVolevoUsarla = function() {
		loan.tenorUnit === 'YEARS' ? loan.tenorInYears * 12 : loan.tenorInYears;
	};


	/**
	 * Get Default Interest Type
	 */
	this.findInterestFromAmount = function(amount, configurationIndex) {

		var interestOptions = loan.activeCurrency.glGenericCalculationList[configurationIndex].interest;
		
		if(!interestOptions) return;
		
		// cicle all interest rates
		var interest = interestOptions.find(function (interest) {  
			var minAmount = interest.amountRange.min;
			var maxAmount = interest.amountRange.max;

			return amount >= minAmount && amount <= maxAmount;
		});

		return interest;
	};

	/**
	 * Get interest value from the period indicated
	 * @param tenor Period in months
	 */
	this.getInterestValueFromTenor = function(interestType, tenor) {
		if(interestType) {
			var periods = interestType.periods;

			var period = periods.find(function(p) {
				return tenor <= p.monthDuration; 
			});

			if(period) return period.interestRate;
		}
	}

	
	/**
	 * Check Errors
	 *
	 */
	this.checkErrors = function() {

		// get parsley errors
		var errors = $( '.parsley-errors-list li', loan.activeCalculator ).length;

		if( errors > 0 ) {

			loan.errorState = true;

		} else {

			loan.errorState = false;

		}

	};


	/**
	 * Calculate Results 
	 */
	this.calculateResults = function() {
		if(loan.errorState === true) return;

		var productCategory = loan.activeVariant.productCategory;

		if(productCategory !== "LOAN_FOR_EVERYTHING" && productCategory !== "OVERDRAFT") {
			
			//get interest rate from input
			var interestRate = loan.interestRate;
			var numberOfRepayments = 0; 

			if(interestRate) {

				if(productCategory === "HOUSING_MORTGAGE" || productCategory === "REFINANCING_LOAN") {

					numberOfRepayments = loan.tenorInYears*12;

					loan.monthlyInstallment = -loan.calculatePMT(interestRate/100/12, numberOfRepayments, loan.borrowAmount).toFixed(2); 
					loan.monthlySavings  = loan.currentMonthlyInstallment - loan.monthlyInstallment;
					loan.totalSavings = loan.monthlySavings * numberOfRepayments;


				}else if(productCategory === "MORTGAGE_FROM_INSTALLMENT") {
					loan.mortgageAmount = Math.round(
						( (1 - Math.pow( 1+interestRate/100*30/360, (- loan.tenorInYears*12)) )/ (interestRate/100*30/360) )
						*loan.currentMonthlyInstallment
					);

					loan.monthlyInstallment = loan.currentMonthlyInstallment;
					numberOfRepayments = loan.tenorInYears*12;

					loan.borrowAmount = loan.mortgageAmount;
				}
				else if(productCategory === "DEFERRED_PAYMENTS_MORTGAGE"){
					var deferredRepayments = loan.deferredRepayments;
					var remainingRepayments = loan.remainingRepayments;
					var mortgageAmount = loan.borrowAmount;

					var v = loan.calculatePMT(interestRate/100/12, remainingRepayments, -mortgageAmount);


					loan.overpayBeforeDeferral = Math.ceil(v);

					var v2 = deferredRepayments*loan.calculateIPMT(interestRate/100/12, 1, remainingRepayments, -mortgageAmount);
					var v3 = loan.calculatePMT(interestRate/100/12,remainingRepayments-deferredRepayments,-mortgageAmount)+(v2/(remainingRepayments-deferredRepayments));
					
					loan.overpayAfterDeferral = Math.ceil(v3);
					loan.overpay = Math.ceil(v2);

				}

				loan.costs = ((loan.monthlyInstallment * numberOfRepayments) + loan.fee + loan.feeForDepositLien).toFixed(2);
				
				var oneTimeFee, monthlyFee, yearFee;
				
				oneTimeFee =  loan.activeCurrency.glGenericCalculationList[0].oneTimeFee;
				
				monthlyFee = loan.activeCurrency.glGenericCalculationList[0].monthlyInsurance;
				
				yearFee = loan.activeCurrency.glGenericCalculationList[0].insuranceFeeYear;
				
				if(productCategory === "HOUSING_MORTGAGE" || productCategory === "REFINANCING_LOAN" || productCategory === "MORTGAGE_FROM_INSTALLMENT") {
					loan.monthlyInsuranceLoan = (loan.borrowAmount*0.000704).toFixed(2);
					monthlyFee = parseFloat(monthlyFee) + parseFloat(loan.monthlyInsuranceLoan);
					
					loan.costs = ((loan.monthlyInstallment * numberOfRepayments) + loan.fee + oneTimeFee + loan.tenorInYears*yearFee + yearFee + loan.loanNumberOfInstallments*monthlyFee ).toFixed(2);
				}
				
				loan.aprc = loan.calculateRPMN(loan.borrowAmount , loan.getTenorInMonths() , oneTimeFee , monthlyFee , yearFee , interestRate ,undefined, undefined);
				
				
				loan.aprc = (loan.aprc * 100).toFixed(2);
				
				
			}
		}
		else if(productCategory === 'LOAN_FOR_EVERYTHING') {
			var loanAmount = loan.borrowAmount;
			var tenorInMonths = loan.tenorInYears;

			var fee = loanAmount*loan.fee;
			loan.fee = fee;

			var withoutBenefit = 0; var withBenefit = 1;

			var interestType = loan.findInterestFromAmount(loanAmount, withBenefit);
			var interestValueWithBenefit = loan.getInterestValueFromTenor( interestType, loan.tenorInYears );

			loan.monthlyInstallment = round( loan.calculatePMT(interestValueWithBenefit/1200, tenorInMonths, -loanAmount), 2 );
			var clientCostsWithBenefit = loan.monthlyInstallment*tenorInMonths + fee; 

			interestType = loan.findInterestFromAmount(loanAmount, withoutBenefit);
			var interestValueWithoutBenefit = loan.getInterestValueFromTenor( interestType, loan.tenorInYears );
			
			loan.interestRateNoBenefit = interestValueWithoutBenefit;
			
			var loanRepayments = round( loan.calculatePMT(interestValueWithoutBenefit/1200, tenorInMonths, -loanAmount), 2 );
			var clientCostsWithoutBenefit = loanRepayments*tenorInMonths + fee; 

			loan.savings = clientCostsWithoutBenefit - clientCostsWithBenefit;

			loan.costs = clientCostsWithBenefit.toFixed(2);

			loan.aprc = loan.calculateLoanRPMN(loanAmount, tenorInMonths , fee , interestValueWithBenefit, undefined , undefined);
			
			
			loan.aprcNoBenefit = loan.calculateLoanRPMN(loanAmount, tenorInMonths , fee , interestValueWithoutBenefit, undefined , undefined);
			
			loan.costsNoBenefit = clientCostsWithoutBenefit.toFixed(2);
			loan.aprc = (loan.aprc * 100).toFixed(2);
			
			loan.aprcNoBenefit = (loan.aprcNoBenefit * 100).toFixed(2);
			loan.monthlyInstallmentNoBenefit = loanRepayments;
			
			loan.interestRate = interestValueWithBenefit;
			
		}else if( productCategory === "OVERDRAFT"){

			var amount = parseFloat(loan.flexidebet);
			
			loan.interestRate = parseFloat(loan.activeCurrency.glGenericCalculationList[0].interest[0].periods[0].interestRate);

			var monthlyInterestPayment = amount * loan.interestRate / 360 * 30 / 100 ;

			monthlyInterestPayment = (Math.floor(parseFloat((monthlyInterestPayment*100).toFixed(2)))/100);
			
			loan.monthlyInterestPayment = monthlyInterestPayment.toFixed(2);

			var amountToBeRepayed = amount + loan.monthlyAccountFee * 3 + monthlyInterestPayment * 3 ;
			
			amountToBeRepayed = (Math.floor(parseFloat((amountToBeRepayed*100).toFixed(2)))/100);
			
			loan.amountToBeRepayed = amountToBeRepayed.toFixed(2);

			loan.aprc = loan.calculateOverdraftRPMN(amount , parseFloat(monthlyInterestPayment), parseFloat(loan.monthlyAccountFee));
			
			
			loan.flexidebetOverdraft = loan.flexidebet;
			
			loan.monthlyAccountFeeOverdraft = loan.monthlyAccountFee;
			
			loan.updateDisclaimerOverdraft();

		}
	};


	this.calculateOverdraftRPMN = function(flexidebet, monthlyInterestPayment, monthlyFee){
			
			var aprc= (Math.pow(((flexidebet + (monthlyInterestPayment + monthlyFee))/flexidebet), 12) - 1);
			aprc = (aprc * 100).toFixed(2);
			
			return aprc;
	};

	//LOAN FOR ANYTHING
	this.calculateLoanRPMN = function(loanAmount, paymentMonth, fee, interest, drawdownDate, firstPaymentDate) {
	
	
	
	
	var drawdownDate = (typeof drawdownDate !== 'undefined') ?  drawdownDate : new Date(); 
	loan.drawDownDate = loan.formatDate(drawdownDate);

	if (typeof firstPaymentDate == 'undefined') {
	firstPaymentDate = new Date(drawdownDate);
	firstPaymentDate.setDate(firstPaymentDate.getDate() + 15);  
	loan.firstInstallmentDate = loan.formatDate(firstPaymentDate);
	}
	
	
	
	var pvif = Math.pow(1 + interest/1200, paymentMonth);
	var pmt = interest/1200 * loanAmount * pvif / (pvif - 1); 
	pmt = Math.round(pmt * 100) / 100; 
	
	
	
	var previousYear = new Date(firstPaymentDate);
	previousYear = previousYear.setFullYear(previousYear.getFullYear() - 1);
	
	
	var daysYear = Math.round((firstPaymentDate - previousYear)/(1000*60*60*24));                                     
	
	
	var t1 = (firstPaymentDate - drawdownDate) /1000/60/60/24 / daysYear;
	
	
	
	var RPMN = 2;               //start RPMN 200%
	var RPMNinterval = RPMN;
	                  
	var i = 0;
	var FINANCIAL_MAX_ITERATIONS = 128; //Bet accuracy with 128
	var FINANCIAL_PRECISION = 0.0000001; //1.0e-8
	                  
	while ((Math.abs(RPMNinterval) > FINANCIAL_PRECISION) && (i < FINANCIAL_MAX_ITERATIONS)) {
	var t = 0;
	var part = 0;
	
	for (var orderMonth = 0; orderMonth <= paymentMonth; orderMonth += 1) {
	var A = (orderMonth !== 0) ? pmt : fee - loanAmount;
	t = (orderMonth == 0) ? 0 : t1 + (orderMonth - 1) / 12;
	
	
	part += A / Math.pow((1 + RPMN), t);
	}
	
	
	RPMNinterval = RPMNinterval/2 
	RPMN = RPMN + RPMNinterval * part / Math.abs(part);
	
	
	++i;
	}
	
	
	return RPMN;
	}
	
	//LOAN MORTGAGE
	this.calculateRPMN = function(loanAmount, paymentMonth, oneTimefee, monthlyFee, yearFee, interest, drawdownDate, firstPaymentDate) {
		  
		  var drawdownDate = (typeof drawdownDate !== 'undefined') ?  drawdownDate : new Date();  
		  loan.drawDownDate = loan.formatDate(drawdownDate);
		  drawdownDate.setHours(0,0,0,0);
		  if (typeof firstPaymentDate == 'undefined') {
		   firstPaymentDate = new Date(drawdownDate.getFullYear(), drawdownDate.getMonth()+1, 5);
		   loan.firstInstallmentDate = loan.formatDate(firstPaymentDate);
		  }

		  var pvif = Math.pow(1 + interest/1200, paymentMonth);
		  var pmt = interest/1200 * loanAmount * pvif / (pvif - 1); 
		  pmt = Math.round(pmt * 100) / 100;  

		  var previousYear = new Date(firstPaymentDate);
		  previousYear = previousYear.setFullYear(previousYear.getFullYear() - 1);
		  var daysYear = Math.round((firstPaymentDate - previousYear)/(1000*60*60*24));                                     

		  var t1 = (firstPaymentDate - drawdownDate) /1000/60/60/24 / daysYear;
		                                     
		  var RPMN = 2;            
		  var RPMNinterval = RPMN;
		                                     
		  var i = 0;
		  var FINANCIAL_MAX_ITERATIONS = 128; 
		  var FINANCIAL_PRECISION = 0.0000001; 
		                                     
		  while ((Math.abs(RPMNinterval) > FINANCIAL_PRECISION) && (i < FINANCIAL_MAX_ITERATIONS)) {
		   var t = 0;
		   var part = 0;

		   for (var orderMonth = 0; orderMonth <= paymentMonth; orderMonth += 1) {
		    var A = (orderMonth !== 0) ? (pmt + monthlyFee) : (oneTimefee + yearFee) - loanAmount;
		    if ((!(orderMonth % 12) && !!orderMonth) == true) { A += yearFee }  // kazdy rok este rocny popl., okrem cerpania

		    t = (orderMonth == 0) ? 0 : (orderMonth - 1) / 12 + t1;
		    part += A / Math.pow((1 + RPMN), t);
		         }

		   RPMNinterval = RPMNinterval/2 
		   RPMN = RPMN + RPMNinterval * part / Math.abs(part);

		   ++i;
		  }

		  return RPMN;
		  }  

	/**
	 * Init Interest Period Select
	 */
	this.initInterestPeriodSelect = function() {

		var periods = loan.activeInterestType.periods;
		var select = $( '.js-interest-period', loan.activeCalculator );

		select.html('');


		if( select.length ) {
			periods.forEach( function( period ) {
				var label = loan.getInterestPeriodLabel(period.monthDuration);
				var $option = $('<option value="' + period.interestRate + '">' + label + '</option>');
				if(period.default) {
					$option.attr("selected", "selected");
					loan.activeInterestPeriod = period;
				}
				select.append($option);
			} );
		}

	};

	this.getInterestPeriodLabel = function(monthDuration){
		return monthDuration/12 + " " + loan.getYearsLabel(monthDuration/12);
	}


	/**
	 * Init Interest Rate Input
	 */
	this.initInterestRateInput = function() {
		var input = $( '[data-algorithm-input="interestRate"]', loan.activeCalculator );

		if( input.length ) {

			var minimumAmount = loan.activeCurrency.glGenericCalculationList[0].minInterestRate;
			var maximumAmount = loan.activeCurrency.glGenericCalculationList[0].maxInterestRate;
			var defaultAmount = loan.activeCurrency.glGenericCalculationList[0].defaultInterestRate;

			// update minimum
			input.attr( 'data-parsley-min', minimumAmount );
			var min = number_format( minimumAmount, 2, genericSettings.decimal, genericSettings.separator );
			$( '[data-interest-min]', loan.activeCalculator ).text( min );

			// update maximum
			input.attr( 'data-parsley-max', maximumAmount );
			var max = number_format( maximumAmount, 2, genericSettings.decimal, genericSettings.separator );
			$( '[data-interest-max]', loan.activeCalculator ).text( max );

			// insert default value if the value is 0
			if ((	input.val() == "0" || parseInt(input.val() ) < defaultAmount)){
				var formattedAmount = number_format( defaultAmount, 2, genericSettings.decimal, genericSettings.separator );
			
				input.val( formattedAmount );

			}

			// validate
			input.parsley(loan.formatParsleyDecimalValue()).validate();

		}

	};


	/**
	 * Init Remaining Repayments Input
	 */
	this.initRemainingRepaymentsInput = function() {
		var input = $( '[data-algorithm-input="remainingRepayments"]', loan.activeCalculator );

		if( input.length ) {

			var minimumAmount = loan.activeCurrency.glGenericCalculationList[0].minRepaymentsUntilEndOfMortgage;
			var defaultAmount = loan.activeCurrency.glGenericCalculationList[0].deafultRepaymentsUntilEndOfMortgage;

			// update minimum
			input.attr( 'data-parsley-min', minimumAmount );
			var min = minimumAmount;
			$( '[data-repayments-min]', loan.activeCalculator ).text( min );

			// insert default value if the value is 0
			if ((	input.val() == "0" || parseInt(input.val() ) < defaultAmount)){
			
				input.val( defaultAmount );

			}

			// validate
			input.parsley().validate();

		}

	};


	/**
	 * Init Required Deferred Repayments Rate Input
	 */
	this.initDeferredRepayments = function() {
		var input = $( '[data-algorithm-input="deferredRepayments"]', loan.activeCalculator );

		if( input.length ) {

			var minimumAmount = loan.activeCurrency.glGenericCalculationList[0].minRequiredDeferredRepayments;
			var maximumAmount = loan.activeCurrency.glGenericCalculationList[0].maxRequiredDeferredRepayments;
			var defaultAmount = loan.activeCurrency.glGenericCalculationList[0].defaultRequiredDeferredRepayments;

			// update minimum
			input.attr( 'data-parsley-min', minimumAmount );
			var min = minimumAmount;
			$( '[data-deferred-repayments-min]', loan.activeCalculator ).text( min );

			// update maximum
			input.attr( 'data-parsley-max', maximumAmount );
			var max = maximumAmount;
			$( '[data-deferred-repayments-max]', loan.activeCalculator ).text( max );

			// insert default value if the value is 0
			if ((	input.val() == "0" || parseInt(input.val() ) < defaultAmount)){
			
				input.val( defaultAmount );

			}

			// validate
			input.parsley().validate();

		}

	};

	this.initFee = function(){
		loan.activeCurrency.glGenericCalculationList[0].fee ? loan.fee = loan.activeCurrency.glGenericCalculationList[0].fee : null ;
	}


	/**
	 * Map Sliders
	 *
	 */
	this.mapSliders = function() {

		if(window.sliderbootstrap) {
			var sliders = window.sliderbootstrap;

			// map every slider with its instance inside sliderbootstrap window property
			sliders.forEach( function( item, index ) {

				item.attr( 'data-slider-index', index );

			} );
		}

	};

	/**
	 * Defines if an input can contain decimals
	 */
	this.formatInputDecimal = function() {
		var $inputs;

		$inputs = $('[data-format-decimal]');
		if( $inputs.length ) {
			$inputs.each(function() {
				new Cleave( this, {
					delimiter: '',
					numeral: true,
					numeralDecimalMark: genericSettings.decimal,
					numeralDecimalScale: 2,
					numeralThousandsGroupStyle: 'thousand'
				} );
			})

		}
		
		$inputs = $('[data-format-no-decimal]');
		if( $inputs.length ) {
			$inputs.each(function() {
					new Cleave( this, {
					delimiter: '',
					numeral: true,
					numeralDecimalMark: genericSettings.decimal,
					numeralDecimalScale: 0,
					numeralThousandsGroupStyle: 'thousand'
				});
			});	
		}
	}

	this.formatParsleyDecimalValue = function() {
		return {
			value: function(parsley) { 
				return $(parsley.element).val().replaceAll(genericSettings.separator, '').replace(genericSettings.decimal,'.'); 
			}
		};

	}

	/**
	 * Calculate PMT
	 * 
	 * @param ir   - interest rate per month
	 * @param np   - number of periods (months)
	 * @param pv   - present value
	 * @param fv   - future value
	 * @param type - when the payments are due:
	 *        0: end of the period, e.g. end of month (default)
	 *        1: beginning of period
	 */
	loan.calculatePMT = function(ir, np, pv, fv, type) {
		var pmt, pvif;

		fv || (fv = 0);
		type || (type = 0);

		if (ir === 0)
			return -(pv + fv)/np;

		pvif = Math.pow(1 + ir, np);
		pmt = - ir * (pv * pvif + fv) / (pvif - 1);

		if (type === 1)
			pmt /= (1 + ir);

		return pmt;
	}

	/**
	 * Calculate IPMT
	 * 
	 * @param ir   - interest rate per month
	 * @param per  - the period for which you want to find the interest
	 * @param np   - number of periods (months)
	 * @param pv   - present value
	 * @param fv   - future value
	 * @param type - when the payments are due:
	 *        0: end of the period, e.g. end of month (default)
	 *        1: beginning of period
	 */
	loan.calculateIPMT = function (ir, per, np, pv, fv, type) {
		fv || (fv = 0);
		type || (type = 0);

		if (per < 1) {
    		return NaN;
  		}
		
		//begin
		if (type === 1 && per === 1) {
			return 0;
		}

  		var totalPmt = loan.calculatePMT(ir, np, pv, fv, type);
		var ipmtVal = loan.FV(ir, per - 1, totalPmt, pv, type) * ir;

		// If paying at the beginning we need to discount by one period
		if (type === 1 && per > 1) {
			ipmtVal = ipmtVal / (1 + ir)
		}

		return ipmtVal;
	}



	/**
	 * Calculate Future Value
	 */
	this.FV = function FV(rate, nper, pmt, pv, type) {
  		var pow = Math.pow(1 + rate, nper), fv;
  		if (rate) {
   			fv = (pmt*(1+rate*type)*(1-pow)/rate)-pv*pow;
  		} else {
   			fv = -1 * (pv + pmt * nper);
  		}
  		return fv.toFixed(2);
	};

	/**
	 * Calculate Rate
	 */
	this.calculateRate = function(nper, pmt, pv, fv, type, guess) {
		if (guess == null) guess = 0.01;
		if (fv == null) fv = 0;
		if (type == null) type = 0;

		var FINANCIAL_MAX_ITERATIONS = 128;
		var FINANCIAL_PRECISION = 0.0000001;

		var y, y0, y1, x0, x1 = 0, f = 0, i = 0;
		var rate = guess;
		  if (Math.abs(rate) < FINANCIAL_PRECISION) {
			y = pv * (1 + nper * rate) + pmt * (1 + rate * type) * nper + fv;
		} else {
			f = Math.exp(nper * Math.log(1 + rate));
			y = pv * f + pmt * (1 / rate + type) * (f - 1) + fv;
		}
		y0 = pv + pmt * nper + fv;
		y1 = pv * f + pmt * (1 / rate + type) * (f - 1) + fv;

		i = x0 = 0.0;
		x1 = rate;
		while ((Math.abs(y0 - y1) > FINANCIAL_PRECISION) && (i < FINANCIAL_MAX_ITERATIONS)) {
			rate = (y1 * x0 - y0 * x1) / (y1 - y0);
			x0 = x1;
			x1 = rate;

			if (Math.abs(rate) < FINANCIAL_PRECISION) {
				y = pv * (1 + nper * rate) + pmt * (1 + rate * type) * nper + fv;
			} else {
				f = Math.exp(nper * Math.log(1 + rate));
				y = pv * f + pmt * (1 / rate + type) * (f - 1) + fv;
			}

			y0 = y1;
			y1 = y;
			++i;
		}
		return rate;
	}

	this.updateDataLayer = function() {
		var dataLayerValue = "";
		var productCategory = loan.activeVariant.productCategory;

		if(productCategory === "HOUSING_MORTGAGE") {
			dataLayerValue = '{ "event": "housing_loan_calculator", "eventCategory": "loan", "eventAction": "[ACTION]", "eventLabel": "[CTA]", "eventName": "housing_loan calculator", "loan_amount": [LOAN_AMOUNT], "currency_code": "[CURRENCY]", "interest_type": "[TYPE]", "loan_duration": [DURATION], "monthly_installment": [INSTALLMENT], "interest_rate": "[RATE]", "fee": [FEE], "housing_loan": "[HOUSING_VALUE]" }';
			dataLayerValue = dataLayerValue.replace('[HOUSING_VALUE]', "Start from amount")
		}
		else if(productCategory === "MORTGAGE_FROM_INSTALLMENT") {
			dataLayerValue = '{ "event": "housing_loan_calculator", "eventCategory": "loan", "eventAction": "[ACTION]", "eventLabel": "[CTA]", "eventName": "housing_loan calculator", "loan_amount": [LOAN_AMOUNT], "currency_code": "[CURRENCY]", "interest_type": "[TYPE]", "loan_duration": [DURATION], "monthly_installment": [INSTALLMENT], "interest_rate": "[RATE]", "fee": [FEE], "housing_loan": "[HOUSING_VALUE]" }';
			dataLayerValue = dataLayerValue.replace('[HOUSING_VALUE]', "Start from installment")
		}
		else {
			dataLayerValue = '{ "event": "loan_calculator", "eventCategory": "loan", "eventAction": "[ACTION]", "eventLabel": "[CTA]", "eventName": "loan calculator", "loan_amount": [LOAN_AMOUNT], "currency_code": "[CURRENCY]", "interest_type": "[TYPE]", "loan_duration": [DURATION], "with_mortgage": "[WITH_MORTGAGE]", "salary_transfer": "[SALARY_TRANSFER]", "monthly_installment": [INSTALLMENT], "amount_to_repay": [REPAY_AMOUNT], "tenor": [TENOR], "interest_rate": "[RATE]", "aprc": [APRC], "approval_cost": [COST], "fee": [FEE] }';
		}

		dataLayerValue = dataLayerValue
							.replace('[LOAN_AMOUNT]', loan.borrowAmount.toFixed(2))
							.replace('[ACTION]', productCategory)
							.replace('[CURRENCY]', loan.activeCurrency.currency)
							.replace('[TYPE]', loan.interestType)
							.replace('[DURATION]', loan.tenorInYears)
							.replace('[TENOR]', loan.tenorInYears)
							.replace('[WITH_MORTGAGE]', 'NO')
							.replace('[SALARY_TRANSFER]', 'NO')
							.replace('[INSTALLMENT]', loan.monthlyInstallment.toFixed(2))
							.replace('[REPAY_AMOUNT]', loan.costs )
							.replace('[RATE]', loan.interestRate)
							.replace('[APRC]', loan.aprc)
							.replace('[COST]', 0)
							.replace('[FEE]', loan.fee)

		loan.dataLayer = dataLayerValue;

	}


	/**
	 * Attach Data Layer Click Event
	 *
	 */
	this.attachDataLayerClickEvent = function() {
		$( document ).on( 'click', '[data-layer-vub-calculator]', function(e) {
			var data = loan.dataLayer;
			

			if($(e.target).hasClass( 'js-callmecta')) {
				data = data.replace('[CTA]', "Call Me Back");
			}
			else {
				data = data.replace('[CTA]', "Get It Now");
			}
			data = JSON.parse( data );

			window.dataLayer.push( data );
		} );

	};

	this.getYearsLabel = function(years) {
		var lang = document.documentElement.lang;
		if(lang === "sk") {
			if(years === 1) {
				return calculatorLabels["YEAR"];
			}
			else if(years === 3 || years === 4)
			{
				return calculatorLabels["YEARS34"];
			}
			else {
				return calculatorLabels["YEARS"];
			}
		}
		else {
			if (years === 1) return calculatorLabels["YEAR"];
			else return calculatorLabels["YEARS"];
		}

	}

	this.formatDate = function (date) {
	    var d = new Date(date),
	        month = '' + (d.getMonth() + 1),
	        day = '' + d.getDate(),
	        year = d.getFullYear();
	
	    if (month.length < 2) 
	        month = '0' + month;
	    if (day.length < 2) 
	        day = '0' + day;
	
	    return [day, month, year].join('.');
	};	

};


/**
 * Get class instance
 *
 */
Intesa.LoanCalculatorVUB.getInstance = function() {

	if( !window.intesa ) {

		window.intesa = new Object();

    }

	if( !window.intesa.loan_calculator_vub ) {

		window.intesa.loan_calculator_vub = new Intesa.LoanCalculatorVUB();

	}

	return window.intesa.loan_calculator_vub;

};
